import { create } from "zustand";
import { LIST_BATIMENT } from "../../Utils/constant";
import { getAll } from "../../services/service";
export const useStoreBatiment = create((set) => ({
  loading: false,
  data: [],
  count: 1,
  batiments: async (param) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const batiments = await getAll(LIST_BATIMENT, param, "");
      setTimeout(() => {
        set({
          loading: false,
          data: batiments.data,
          count: batiments.data.totalPages,
        });
      }, 800);
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
}));
